module.exports = __webpack_public_path__ + "img/04_ok.95d0f2b1.png";